// extracted by mini-css-extract-plugin
export default {"row":"LayoutCentredView_row__grnen"};